// @ts-nocheck

import { uniq as _uniq } from 'lodash';

import { FavoriteActionTypes } from '../types/actions/favorite';

export const favoritesInitialState = {
  ids: [],
};

export default (state = favoritesInitialState, action) => {
  switch (action.type) {
    case FavoriteActionTypes.RECEIVE: {
      const { matchIds } = action.payload;
      return {
        ...state,
        ids: matchIds,
      };
    }
    case FavoriteActionTypes.ADD: {
      const { matchId } = action.payload;
      return {
        ...state,
        ids: _uniq([...state.ids, matchId]),
      };
    }
    case FavoriteActionTypes.PURGE: {
      return {
        ...state,
        ids: [],
      };
    }
    case FavoriteActionTypes.DEL: {
      const { matchId } = action.payload;
      const index = state.ids.indexOf(matchId);
      if (index !== -1) {
        return {
          ...state,
          ids: [...state.ids.slice(0, index), ...state.ids.slice(index + 1, state.ids.length)],
        };
      }
      return state;
    }
    default:
      return state;
  }
};
